"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'en': {
        'translation': {
            'Selected': 'Selected',
            'Total': 'Total',
            'Global Search': 'Global Search',
            'No records found': 'No records found'
        }
    },
    'es': {
        'translation': {
            'Selected': 'Seleccionada',
            'Total': 'Total',
            'Global Search': 'Busqueda global',
            'No records found': 'No se encontrarón archivos'
        }
    },
    'cs': {
        'translation': {
            'Selected': 'vybraný',
            'Total': 'Celkem',
            'Global Search': 'Hledaný výraz',
            'No records found': 'Nebyl nalezen žádný výsledek'
        }
    },
    'zh': {
        'translation': {
            'Selected': '选取',
            'Total': '总数',
            'Global Search': '全局搜索',
            'No records found': '没有找到结果'
        }
    },
    'he': {
        'translation': {
            'Selected': 'נבחר',
            'Total': 'סה״כ',
            'Global Search': 'חפש בכל',
            'No records found': 'לא נמצאו תוצאות'
        }
    }
};
//# sourceMappingURL=translations.js.map